import React from "react";
import styled, { css } from "styled-components";
import { GridContainer } from "../ProductsList/ProductsListElements";
import { VisuallyHidden } from "../../general/Typography";
import { colors, radii, shimmer } from "../../../theme";

const shimmerBackground = css`
  background: linear-gradient(
    90deg,
    ${colors.backgroundTernary} 0%,
    ${colors.backgroundMain} 50%,
    ${colors.backgroundTernary} 100%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 1.6s linear infinite;
`;

const ProductsSkeleton = ({ label, count = 8 }) => (
  <Wrapper role="status" aria-live="polite">
    <VisuallyHidden>{label}</VisuallyHidden>
    <TitleBlock />
    <GridContainer aria-hidden>
      {Array.from({ length: count }, (_, index) => (
        <Card key={index}>
          <Media />
          <Lines>
            <Line $width="70%" />
            <Line $width="95%" />
            <Line $width="45%" />
          </Lines>
        </Card>
      ))}
    </GridContainer>
  </Wrapper>
);

const Wrapper = styled.div`
  padding: 2.5rem 0;
`;

const TitleBlock = styled.div`
  width: 12rem;
  height: 2.25rem;
  margin-bottom: 2rem;
  border-radius: ${radii.sm};
  ${shimmerBackground}
`;

const Card = styled.div`
  overflow: hidden;
  border: 1px solid rgba(210, 180, 140, 0.35);
  border-radius: ${radii.lg};
  background-color: ${colors.backgroundSecondary};
`;

const Media = styled.div`
  aspect-ratio: 4 / 3;
  ${shimmerBackground}
`;

const Lines = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1.25rem;
`;

const Line = styled.div`
  width: ${({ $width }) => $width};
  height: 0.9rem;
  border-radius: ${radii.pill};
  ${shimmerBackground}
`;

export default ProductsSkeleton;
